import React, { useState } from 'react';
import {
  Card,
  Title,
  Text,
  TextInput,
  Button,
  Select,
  SelectItem,
  Grid,
  List,
  ListItem,
  Badge,
  MultiSelect,
  MultiSelectItem
} from '@tremor/react';

export function CustomReportsPage() {
  const [savedReports, setSavedReports] = useState([
    {
      id: 1,
      name: 'Custom Repair Analysis',
      creator: 'John Doe',
      lastRun: '2024-03-20',
      dataSource: 'repairs'
    },
    {
      id: 2,
      name: 'AI Cost Savings Report',
      creator: 'Jane Smith',
      lastRun: '2024-03-19',
      dataSource: 'ai'
    }
  ]);

  const [newReport, setNewReport] = useState({
    name: '',
    dataSource: '',
    metrics: [],
    filters: [],
    groupBy: ''
  });

  const dataSources = [
    { value: 'reCommerce', label: 'Re-Commerce Transactions' },
    { value: 'ai', label: 'AI Logs' },
    { value: 'finance', label: 'Finance Transactions' },
    { value: 'inventory', label: 'Inventory' },
    { value: 'customers', label: 'Customers' }
  ];

  const metrics = [
    { value: 'revenue', label: 'Revenue' },
    { value: 'count', label: 'Count' },
    { value: 'average', label: 'Average' },
    { value: 'cost', label: 'Cost' }
  ];

  const groupByOptions = [
    { value: 'category', label: 'Category' },
    { value: 'location', label: 'Location' },
    { value: 'date', label: 'Date' },
    { value: 'status', label: 'Status' }
  ];

  const handleInputChange = (field, value) => {
    setNewReport(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handlePreview = () => {
    // TODO: Implement preview functionality
    console.log('Preview report:', newReport);
  };

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log('Save report:', newReport);
  };

  return (
    <div className="space-y-6">
      <div>
        <Title>Custom Reports</Title>
        <Text>Build and save custom reports for your specific needs</Text>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Card>
            <Title>New Custom Report</Title>
            <div className="mt-6 space-y-6">
              <div className="space-y-2">
                <label className="text-sm font-medium">Report Name</label>
                <TextInput
                  placeholder="Enter report name"
                  value={newReport.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                />
              </div>

              <div className="space-y-2">
                <label className="text-sm font-medium">Data Source</label>
                <Select
                  value={newReport.dataSource}
                  onValueChange={(value) => handleInputChange('dataSource', value)}
                >
                  {dataSources.map((source) => (
                    <SelectItem key={source.value} value={source.value}>
                      {source.label}
                    </SelectItem>
                  ))}
                </Select>
              </div>

              <div className="space-y-2">
                <label className="text-sm font-medium">Metrics</label>
                <MultiSelect
                  value={newReport.metrics}
                  onValueChange={(value) => handleInputChange('metrics', value)}
                >
                  {metrics.map((metric) => (
                    <MultiSelectItem key={metric.value} value={metric.value}>
                      {metric.label}
                    </MultiSelectItem>
                  ))}
                </MultiSelect>
              </div>

              <div className="space-y-2">
                <label className="text-sm font-medium">Group By</label>
                <Select
                  value={newReport.groupBy}
                  onValueChange={(value) => handleInputChange('groupBy', value)}
                >
                  {groupByOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </Select>
              </div>

              <div className="flex justify-end space-x-4">
                <Button variant="secondary" onClick={handlePreview}>
                  Preview Results
                </Button>
                <Button onClick={handleSave}>Save Report</Button>
              </div>
            </div>
          </Card>
        </div>

        <Card>
          <Title>Saved Custom Reports</Title>
          <List className="mt-4">
            {savedReports.map((report) => (
              <ListItem key={report.id}>
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <Text className="font-medium">{report.name}</Text>
                    <Badge size="sm">{report.dataSource}</Badge>
                  </div>
                  <div className="flex items-center justify-between text-sm text-tremor-content-subtle">
                    <Text>Created by: {report.creator}</Text>
                    <Text>Last run: {report.lastRun}</Text>
                  </div>
                  <div className="flex space-x-2">
                    <Button size="xs" variant="secondary">Edit</Button>
                    <Button size="xs" variant="secondary">Run</Button>
                    <Button size="xs" variant="secondary" color="red">Delete</Button>
                  </div>
                </div>
              </ListItem>
            ))}
          </List>
        </Card>
      </div>
    </div>
  );
} 